var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.submitErrors');
    };
  };
};

export default createGetFormSubmitErrors;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormSubmitErrors.js
// module id = 1219
// module chunks = 0